import { Pipe, PipeTransform } from "@angular/core";
import { DateTime } from "luxon";

/**
 * Converte uma data ISO em tempo relativo em pt-BR (ex.: "há 5 minutos").
 * Impuro para refletir a passagem do tempo entre renders.
 */
@Pipe({
  name: "relativeTime",
  standalone: true,
  pure: false,
})
export class RelativeTimePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return "";
    }

    const dateTime = DateTime.fromISO(value).setLocale("pt-BR");
    if (!dateTime.isValid) {
      return "";
    }

    return dateTime.toRelative() ?? "";
  }
}
